import { t } from "i18next";
import UserAlertDetails from "../types/dtos/alert/UserAlertDetails";

const alertHelper = {
  /** Processes the dates (back to local), message and href */
  processAlertDetails: function (alertData: UserAlertDetails): UserAlertDetails {
    alertData.recentNotifications.forEach((alert) => {
      // Convert the dates from Utc back to local via JS object
      alert.dateSent = new Date(alert.dateSent);
      if (alert.dateRead != null) {
        alert.dateRead = new Date(alert.dateRead);
      }

      // Find the relevant type for the current alert
      const relevantAlertType = alertData.notificationTypes.find(x => x.id === alert.notificationType);
      if (relevantAlertType != null) {
        // If found then we need to pull out the translation key to use
        const translationKey = alert.useManagerTranslationKeyForMessage
                        ? relevantAlertType.managerTranslationKey
                        : relevantAlertType.employeeTranslationKey;
        if (translationKey != null) {
          // Translate the key so that we can use the message to parse.
          let message = t(translationKey);

          // Loop over the alertType parameters and try to find a match
          relevantAlertType.parameters.forEach((typeParam) => {
            const match = alert.paramValues.find(x => x.parameterId === typeParam.id);
            if (match != null) {
              // If a match is found then check the ParamType and see if it needs to be parsed into
              // the Title or Url
              switch (typeParam.paramType) {
                case "Title":
                  message = message.replace("{" + typeParam.paramKey + "}", match.value);
                  break;
                case "Url":
                  if (alert.href != null) {
                    alert.href = alert.href.replace("{" + typeParam.paramKey + "}", match.value);
                  }
                  break;
              }
            }
          });

          // Set the message against the alert
          alert.message = message;
        }
      }
    });

    return alertData;
  },
};

export default alertHelper;
